<template>
  <page-view :title="title">
    <a-card :bordered="false">
      <a-space>
        <a-input placeholder="商品名" v-model="queryParam.name" />
        <a-button @click="$refs.table.refresh(false)">
          查询
        </a-button>
        <a-button @click="insert">
          新增
        </a-button>
        <a-button @click="batchUpDown(true)">
          批量上架
        </a-button>
        <a-button @click="batchUpDown(false)">
          批量下架
        </a-button>
      </a-space>
      <s-table
        style="margin-top: 10px"
        ref="table"
        size="small"
        rowKey="id"
        :columns="columns"
        :data="dataSource"
        :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange
        }"
      >
        <span slot="serial" slot-scope="text, record, index">
          {{ index + 1 }}
        </span>
        <template slot="sort" slot-scope="text, record">
          <span v-if="!editObj[record.id]">
            {{ text }}
            <a-icon type="edit" @click="addEdit(record)" />
          </span>
          <a-space direction="vertical" v-else>
            <a-input v-model="editObj[record.id].sort" style="width: 60px;" />
            <a-space>
              <a @click="cancelEdit(record.id)">取消</a>
              <span style="margin: 0 2px;">|</span>
              <a @click="editAdr(record.id)">确认</a>
            </a-space>
          </a-space>
        </template>
        <template slot="picture" slot-scope="text, record">
          <img
            :src="text"
            style="width: 45px;height: 45px;"
            @click="() => (preview = { show: true, image: text })"
          />
        </template>
        <template slot="enabled" slot-scope="text, record">
          <a-switch
            checked-children="上架"
            un-checked-children="下架"
            v-model="record.enabled"
            :loading="record.loading"
            @change="updateEnabled(record)"
          />
        </template>
        <template slot="operation" slot-scope="text, record">
          <a-popconfirm
            title="确认删除，不可恢复哦?"
            @confirm="() => deleteGoods(record)"
          >
            <a href="javascript:;">删除</a>
          </a-popconfirm>
          <a style="margin-left: 8px;" @click="update(record)">修改</a>
        </template>
      </s-table>
      <a-modal
        title="编辑"
        :width="800"
        :visible="edit.show"
        v-if="edit.show"
        :maskClosable="false"
        @cancel="handleCancel"
        @ok="handleOk"
      >
        <div style="height: 900px; overflow-y: auto;">
          <a-form layout="horizontal" v-bind="formCol">
            <a-form-item label="商品名称">
              <a-input
                placeholder="商品名"
                v-model="edit.name"
                style="width: 395px"
              />
            </a-form-item>
            <a-form-item label="长标题内容">
              <a-input
                placeholder="长标题内容"
                v-model="edit.title"
                style="width: 395px"
              />
            </a-form-item>
            <!-- （如果不接通第三方平台进行发货，请勿填写） -->
            <a-form-item label="现价">
              <a-input-number
                :precision="2"
                placeholder="现价"
                v-model="edit.price"
                style="width: 395px"
              />
            </a-form-item>
            <a-form-item label="官方提成">
              <a-input-number
                :precision="3"
                placeholder="官方提成(收到金额=现价-官方提成)"
                v-model="edit.adminPrice"
                style="width: 395px"
              />
            </a-form-item>
            <a-form-item label="重量">
              <a-input-number
                :precision="2"
                placeholder="重量"
                v-model="edit.weight"
                style="width: 395px"
              />
            </a-form-item>
            <a-form-item label="库存">
              <a-input-number
                :precision="0"
                placeholder="库存"
                v-model="edit.stock"
                style="width: 395px"
              />
            </a-form-item>
            <a-form-item label="商品主图">
              <a-upload
                list-type="picture-card"
                :file-list="edit.mainImgFileList"
                :customRequest="f => customRequest(f, 'mainImgFileList')"
                :remove="f => remove(f, 'mainImgFileList')"
                @preview="handlePreview"
              >
                <div v-if="edit.mainImgFileList.length < 5">
                  <a-icon type="plus" />
                  <div class="ant-upload-text">
                    上传主图
                  </div>
                </div>
              </a-upload>
            </a-form-item>
            <a-form-item label="商品详情图">
              <a-upload
                list-type="picture-card"
                :file-list="edit.detailImgFileList"
                :customRequest="f => customRequest(f, 'detailImgFileList')"
                :remove="f => remove(f, 'detailImgFileList')"
                multiple
                @preview="handlePreview"
              >
                <div>
                  <a-icon type="plus" />
                  <div class="ant-upload-text">
                    上传详情图
                  </div>
                </div>
              </a-upload>
            </a-form-item>
            <a-form-item label="淘宝类目">
              <SelectCate
                v-model="edit.catIdTb"
                platform="tb"
                style="width: 395px"
                :name="edit.catNameTb"
                @nameChange="name => (edit.catNameTb = name)"
              />
            </a-form-item>
            <a-form-item label="抖音类目">
              <SelectCate
                v-model="edit.catIdDy"
                platform="dy"
                style="width: 395px"
                :name="edit.catNameDy"
                @nameChange="name => (edit.catNameDy = name)"
              />
            </a-form-item>
            <a-form-item label="拼多多类目">
              <SelectCate
                v-model="edit.catIdPdd"
                platform="pdd"
                style="width: 395px"
                :name="edit.catNamePdd"
                @nameChange="name => (edit.catNamePdd = name)"
              />
            </a-form-item>
            <a-form-item label="快手类目">
              <SelectCate
                v-model="edit.catIdKs"
                platform="ks"
                style="width: 395px"
                :name="edit.catNameKs"
                @nameChange="name => (edit.catNameKs = name)"
              />
            </a-form-item>
            <a-form-item label="小红书类目">
              <SelectCate
                v-model="edit.catIdXhs"
                platform="xhs"
                style="width: 395px"
                :name="edit.catNameXhs"
                @nameChange="name => (edit.catNameXhs = name)"
              />
            </a-form-item>
            <a-form-item label="1688类目">
              <SelectCate
                v-model="edit.catIdAli"
                platform="ali"
                style="width: 395px"
                :name="edit.catNameAli"
                @nameChange="name => (edit.catNameAli = name)"
              />
            </a-form-item>
            <a-form-item label="jd类目">
              <SelectCate
                v-model="edit.catIdJd"
                platform="jd"
                style="width: 395px"
                :name="edit.catNameJd"
                @nameChange="name => (edit.catNameJd = name)"
              />
            </a-form-item>
          </a-form>
        </div>
      </a-modal>
      <a-modal
        :visible="preview.show"
        :footer="null"
        @cancel="() => (preview.show = false)"
      >
        <img style="width: 100%" :src="preview.image" />
      </a-modal>
    </a-card>
  </page-view>
</template>
<script>
import SelectCate from "./components/selectCate";
import { STable } from "@/components";
import { PageView } from "@/layouts";
import {
  goodsList,
  goodsListAll,
  goodsInsert,
  goodsUpdate,
  goodsPartitionList
} from "@/api";
import { formatDate, uuid, getBase64, uploadFileToOSS } from "@/utils/util";
// import lrz from 'lrz'

export default {
  props: {
    admin: {
      type: Boolean,
      default: false
    },
    uid: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      formCol: { labelCol: { span: 5 }, wrapperCol: { span: 19 } },
      selectedRowKeys: [],
      selectedRows: [],
      preview: { image: "", show: false },
      // partitionList: [],
      goodsAll: [],
      hasInsert: true,
      edit: { show: false, mainImgFileList: [], detailImgFileList: [] },
      queryParam: {},
      columns: [
        {
          title: "#",
          scopedSlots: { customRender: "serial" }
        },
        {
          title: "排序",
          dataIndex: "sort",
          scopedSlots: { customRender: "sort" }
        },
        // {
        //   title: "主图",
        //   dataIndex: "mainPics",
        //   scopedSlots: { customRender: "mainPics" }
        // },
        {
          title: "主图",
          dataIndex: "picture",
          scopedSlots: { customRender: "picture" }
        },
        {
          title: "商品名",
          dataIndex: "name"
        },
        {
          title: "售价",
          dataIndex: "price",
          sorter: true
        },
        {
          title: "官方提成",
          dataIndex: "adminPrice",
          sorter: true
        },
        {
          title: "重量",
          dataIndex: "weight",
          sorter: true
        },
        {
          title: "库存",
          dataIndex: "stock",
          sorter: true,
          width: "10%"
        },
        {
          title: "销量",
          dataIndex: "sales",
          sorter: true,
          width: "10%"
        },
        {
          title: "状态",
          dataIndex: "enabled",
          scopedSlots: { customRender: "enabled" },
          sorter: true,
          width: "10%"
        },
        {
          title: "创建时间",
          dataIndex: "createTime",
          sorter: true,
          customRender: formatDate
        },
        {
          title: "修改时间",
          dataIndex: "updateTime",
          sorter: true,
          customRender: formatDate
        },
        {
          title: "操作",
          dataIndex: "id",
          scopedSlots: { customRender: "operation" }
        }
      ],
      dataSource: parameter => {
        const extra = {
          admin: this.admin || undefined,
          uid: this.uid || undefined
        };
        return goodsList(Object.assign(parameter, this.queryParam, extra)).then(
          result => {
            return result.data;
          }
        );
      },
      editObj: {}
    };
  },
  created() {
    // goodsPartitionList().then(res => {
    //   this.partitionList = res.data;
    // });
    goodsListAll({ pageNum: 1, pageSize: 1000000, showAdmin: true }).then(
      res => {
        if (res.success) {
          this.goodsAll = res.data.list;
        } else {
        }
      }
    );
  },
  components: {
    PageView,
    STable,
    SelectCate
  },
  methods: {
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      this.preview.show = true;
      this.preview.image = file.url || file.preview;
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
    async batchUpDown(enabled) {
      if (!this.selectedRowKeys.length) {
        return this.$message.error("请选择商品！");
      }
      for (let index = 0; index < this.selectedRows.length; index++) {
        const row = this.selectedRows[index];
        row.enabled = enabled;
        const extra = {
          admin: this.admin || undefined,
          uid: this.uid || undefined
        };
        await goodsUpdate({ ...row, ...extra });
      }
      this.$message.success("操作成功");
      this.$refs.table.refresh(false);
      this.selectedRowKeys = [];
      this.selectedRows = [];
    },
    filterOldOption(input, option) {
      console.info("option", option, input);
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    // handleSelectOld(value) {
    //   this.goodsAll.forEach(it => {
    //     if (it.id === value) {
    //       it.show = true;
    //       this.preview.image = it.picture;
    //       this.edit = JSON.parse(JSON.stringify(it));
    //     }
    //   });
    // },
    updateEnabled(record) {
      // record.enabled = !record.enabled;
      record.loading = true;
      const extra = {
        admin: this.admin || undefined,
        uid: this.uid || undefined
      };
      goodsUpdate({ ...record, ...extra }).then(res => {
        record.loading = false;
        this.handleRes(res);
      });
    },
    remove(file, type) {
      this.edit[type] = this.edit[type].filter(val => val.uid !== file.uid);
      return true;
    },
    removeDetail(file) {
      this.edit.detailImgFileList = this.edit.detailImgFileList.filter(
        val => val.uid !== file.uid
      );
      return true;
    },
    async customRequest(fileData, type) {
      const res = await uploadFileToOSS(fileData);
      if (res.code !== 0) {
        fileData.onError();
        return;
      }
      fileData.onSuccess();
      console.log("[res] ---> ", res);

      this.edit[type].push({
        uid: this.edit[type]?.length || 0,
        name: `${new Date().getTime()}`,
        status: "done",
        url: res.data
      });
    },
    deleteGoods(record) {
      record.flag = !record.flag;
      const extra = {
        admin: this.admin || undefined,
        uid: this.uid || undefined
      };
      goodsUpdate({ ...record, ...extra }).then(res => {
        this.handleRes(res);
      });
    },
    update(record) {
      this.hasInsert = false;
      record.show = true;
      record.mainImgFileList = JSON.parse(record.mainPics || "[]").map(
        (url, index) => ({
          uid: `${new Date().getTime()}_${index}`,
          name: `${new Date().getTime()}_${index}`,
          status: "done",
          url
        })
      );
      record.detailImgFileList = JSON.parse(record.detailPics || "[]").map(
        (url, index) => ({
          uid: `${new Date().getTime()}_${index}`,
          name: `${new Date().getTime()}_${index}`,
          status: "done",
          url
        })
      );
      console.log("[record] ---> ", record);
      this.edit = JSON.parse(JSON.stringify(record));
    },
    insert() {
      // this.preview.image = "";
      this.edit = { show: true, mainImgFileList: [], detailImgFileList: [] };
      this.hasInsert = true;
    },
    handleCancel() {
      this.edit = { show: false, mainImgFileList: [], detailImgFileList: [] };
    },
    handleOk() {
      const edit = JSON.parse(JSON.stringify(this.edit));
      // TODO 待改字段
      edit.mainPics = JSON.stringify(
        edit.mainImgFileList.map(val => val.url).filter(val => val)
      );
      edit.detailPics = JSON.stringify(
        edit.detailImgFileList.map(val => val.url).filter(val => val)
      );
      delete edit.mainImgFileList;
      delete edit.detailImgFileList;
      edit.original = edit.price;
      edit.enabled = false;
      edit.picture = JSON.parse(edit.mainPics || JSON.stringify([]))[0];
      const extra = {
        admin: this.admin || undefined,
        uid: this.uid || undefined
      };
      const data = { ...edit, ...extra };
      console.log("[data] ---> ", data);
      if (this.hasInsert) {
        goodsInsert({ ...edit, ...extra }).then(res => {
          this.handleRes(res);
        });
      } else {
        goodsUpdate({ ...edit, ...extra }).then(res => {
          this.handleRes(res);
        });
      }
    },
    handleRes(res) {
      if (res.success) {
        this.$message.success("成功");
        this.$refs.table.refresh(false);
        this.edit = { show: false, mainImgFileList: [], detailImgFileList: [] };
      } else {
        this.$message.error(res.msg);
      }
    },
    addEdit(record) {
      this.$set(this.editObj, record.id, JSON.parse(JSON.stringify(record)));
    },
    cancelEdit(id) {
      this.$set(this.editObj, id, null);
    },
    async editAdr(id) {
      const extra = {
        admin: this.admin || undefined,
        uid: this.uid || undefined
      };
      const res = await goodsUpdate({ ...this.editObj[id], ...extra });
      if (res.code === 0) {
        this.$message.success("修改成功");
        this.$set(this.editObj, id, null);
        this.$refs.table.refresh(false);
      } else {
        this.$message.error(res.msg);
      }
    }
  },
  computed: {
    title() {
      return this.$route.meta.title;
    }
  }
};
</script>

<style lang="less" scoped>
.top5 {
  margin-bottom: 8px;
}
</style>
